<template>
  <el-main class="digital-human-layout">
    <el-container>
      <!-- 顶部横幅 -->
      <div class="hero-banner">
        <div class="hero-banner-content">
          <div class="hero-left">
            <h1 class="hero-title">打造你的数字人IP形象</h1>
            <p class="hero-subtitle">专业数字人视频制作，让AI为你代言</p>
            <div class="hero-actions">
              <el-button type="primary" class="create-btn" @click="switchTab('manage')">
                立即体验 →
              </el-button>
            </div>
          </div>
          <div class="hero-right">
            <div class="hero-visual">
              <i class="el-icon-video-camera" style="font-size: 48px; color: #fff;"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab切换区域 -->
      <el-header class="header">
        <div class="item" :class="{ active: activeTab === 'generate' }" @click="switchTab('generate')">
          <i class="el-icon-video-camera" :style="{ fontSize: '16px', color: activeTab === 'generate' ? '#7848f1' : '#666' }"></i>
          <span>视频生成</span>
        </div>
        <div class="item" :class="{ active: activeTab === 'manage' }" @click="switchTab('manage')">
          <i class="el-icon-user-solid" :style="{ fontSize: '16px', color: activeTab === 'manage' ? '#7848f1' : '#666' }"></i>
          <span>数字人管理</span>
        </div>
        <div class="item" :class="{ active: activeTab === 'voice' }" @click="switchTab('voice')">
          <i class="el-icon-microphone" :style="{ fontSize: '16px', color: activeTab === 'voice' ? '#7848f1' : '#666' }"></i>
          <span>音色训练</span>
        </div>
      </el-header>

      <!-- 主要内容区域 -->
      <el-main class="main-content">
        <!-- 视频生成内容 -->
        <div class="video-section" v-show="activeTab === 'generate'">
          <div class="content-layout">
            <!-- 左侧：视频预览和描述 -->
            <div class="video-left">
              <div class="video-preview">
                <el-image
                  :src="getCurrentAvatarImage()"
                  fit="cover"
                  class="video-preview-image"
                >
                  <div slot="placeholder" class="image-slot">
                    <i class="el-icon-picture" style="font-size: 48px; color: #ccc;"></i>
                  </div>
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture" style="font-size: 48px; color: #ccc;"></i>
                  </div>
                </el-image>

                <!-- <div class="video-info">
                  <div class="duration">1:30</div>
                  <div class="download-btn">
                    <i class="el-icon-download" style="font-size: 16px;"></i>
                  </div>
                </div> -->
              </div>
              <!-- 文本输入区域 -->
              <div class="text-input-section">
                <h3 class="input-title">输入文本内容</h3>
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入要生成视频的文本内容..."
                  v-model="inputText"
                  class="text-input"
                ></el-input>

                <!-- 背景设置（选填）。仅支持移除原背景的形象可用 -->
                <div class="bg-section">
                  <div class="bg-header">
                    <h3 class="input-title">背景<span class="bg-optional">（选填）</span></h3>
                    <span class="bg-tip" v-if="canSetBackground">
                      不设置时保留形象自带的背景
                    </span>
                    <span class="bg-tip bg-tip-disabled" v-else>
                      当前形象不支持更换背景，请选择带「可换背景」标记的形象
                    </span>
                  </div>

                  <div class="bg-body" v-if="canSetBackground">
                    <el-upload
                      class="bg-uploader"
                      :action="`${config.baseUrl}user/api.userinfo/uploadImg`"
                      :data="{ merchant_guid: $store.state.merchantGuid }"
                      name="img"
                      :show-file-list="false"
                      :before-upload="beforeBgUpload"
                      :on-success="handleBgUploadSuccess"
                      :on-error="handleBgUploadError"
                    >
                      <div class="bg-thumb" v-if="bgSrcUrl">
                        <img :src="bgSrcUrl" class="bg-thumb-img" />
                        <div class="bg-thumb-mask">点击更换</div>
                      </div>
                      <div class="bg-empty" v-else v-loading="bgUploading">
                        <i class="el-icon-picture-outline"></i>
                        <span>上传背景图</span>
                      </div>
                    </el-upload>

                    <div class="bg-meta">
                      <p class="bg-meta-line">支持 JPG / PNG，建议尺寸与视频一致（{{ bgRecommendSize }}）</p>
                      <el-button
                        v-if="bgSrcUrl"
                        type="text"
                        size="mini"
                        class="bg-clear"
                        @click="clearBackground"
                      >
                        移除背景图
                      </el-button>
                    </div>
                  </div>
                </div>

                <!-- 配音音色选择 -->
                <div class="voice-select-row">
                  <span class="voice-select-label">配音音色</span>
                  <el-select v-model="selectedVoiceId" size="small" placeholder="形象自带音色" class="voice-select">
                    <el-option label="形象自带音色" value=""></el-option>
                    <el-option
                      v-for="a in availableAudioOptions"
                      :key="a.chanjingAudioId"
                      :label="a.audioName + '（我的克隆）'"
                      :value="a.chanjingAudioId"
                    ></el-option>
                  </el-select>
                  <el-button type="text" size="mini" @click="switchTab('voice')">去克隆声音 →</el-button>
                </div>

                <!-- 高级设置 -->
                <div class="advanced-section">
                  <div class="advanced-toggle" @click="showAdvanced = !showAdvanced">
                    <i :class="showAdvanced ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                    <span>高级设置</span>
                  </div>
                  <div class="advanced-body" v-show="showAdvanced">
                    <div class="adv-row">
                      <span class="adv-label">清晰度</span>
                      <el-radio-group v-model="videoParams.resolutionRate" size="mini">
                        <el-radio-button :label="0">1080P</el-radio-button>
                        <el-radio-button :label="1">4K</el-radio-button>
                      </el-radio-group>
                    </div>
                    <div class="adv-row">
                      <span class="adv-label">画质</span>
                      <el-radio-group v-model="videoParams.model" size="mini">
                        <el-radio-button :label="0">基础版</el-radio-button>
                        <el-radio-button :label="1">高质版</el-radio-button>
                      </el-radio-group>
                    </div>
                    <div class="adv-row">
                      <span class="adv-label">播放顺序</span>
                      <el-radio-group v-model="videoParams.backway" size="mini">
                        <el-radio-button :label="1">正放</el-radio-button>
                        <el-radio-button :label="2">倒放</el-radio-button>
                      </el-radio-group>
                    </div>
                    <div class="adv-row">
                      <span class="adv-label">显示字幕</span>
                      <el-switch v-model="videoParams.subtitleShow"></el-switch>
                    </div>
                    <div class="adv-row">
                      <span class="adv-label">合规水印</span>
                      <el-switch v-model="videoParams.addComplianceWatermark"></el-switch>
                    </div>
                    <div class="adv-row adv-row-offset">
                      <span class="adv-label">人物偏移</span>
                      <div class="adv-offset">
                        <span class="adv-offset-label">水平</span>
                        <el-input-number v-model="videoParams.personX" :step="10" size="mini" controls-position="right"></el-input-number>
                        <span class="adv-offset-label">垂直</span>
                        <el-input-number v-model="videoParams.personY" :step="10" size="mini" controls-position="right"></el-input-number>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 收费展示 -->
                <div class="fee-section" v-if="pointsConfig">
                  <div class="fee-line">
                    <span class="fee-item">基础 <b>{{ pointsConfig.basePoints }}</b> 点</span>
                    <span class="fee-item">每秒 <b>{{ pointsConfig.pointsPerSecond }}</b> 点</span>
                    <span class="fee-item" v-if="pointsConfig.isLoggedIn">余额 <b>{{ pointsConfig.currentPoints }}</b> 点</span>
                  </div>
                  <div class="fee-estimate" v-if="estimateInfo">
                    预计消耗约 <b>{{ estimateInfo.requiredPoints }}</b> 点（约 {{ estimateInfo.videoSeconds }} 秒）
                    <span class="fee-shortfall" v-if="estimateInfo.isEnough === false">余额不足，还差 {{ estimateInfo.shortfall }} 点</span>
                  </div>
                  <div class="fee-note">
                    {{ pointsConfig.videoCostFormula }}；克隆声音 {{ pointsConfig.cloneAudioPoints }} 点/次、克隆形象 {{ pointsConfig.clonePersonPoints }} 点/次
                  </div>
                </div>

                <div class="generate-actions">
                  <el-button type="primary" class="generate-btn" @click="generateVideo" :loading="generating">
                    立即生成
                  </el-button>
                </div>
              </div>
            </div>

          <!-- 右侧：数字人形象和生成记录 -->
          <div class="video-right">
            <!-- 数字人形象选择 -->
            <div class="avatar-section">
              <h4 class="subsection-title">数字人形象</h4>
              <div class="avatar-preview">
                <div class="avatar-video-container">
                  <div class="video-placeholder">
                    <el-image
                      :src="getCurrentAvatarImage()"
                      fit="cover"
                      class="current-avatar-image"
                    >
                      <div slot="placeholder" class="image-slot">
                        <i class="el-icon-picture" style="font-size: 48px; color: #ccc;"></i>
                      </div>
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture" style="font-size: 48px; color: #ccc;"></i>
                      </div>
                    </el-image>
                  </div>
                  <el-button
                    size="mini"
                    type="primary"
                    class="switch-btn"
                    @click="showAvatarSelector = true"
                  >
                    切换
                  </el-button>
                </div>
                <div class="avatar-name-display">
                  {{ getCurrentAvatarName() }}
                </div>
              </div>
            </div>

            <!-- 生成记录 -->
            <div class="history-section">
              <h4 class="subsection-title">生成记录</h4>
              <div class="history-list" v-loading="historyLoading">
                <div class="history-item" v-for="item in generationHistory" :key="item.id">
                  <div class="history-icon">
                    <i class="el-icon-video-camera" style="font-size: 14px; color: #6366f1;"></i>
                  </div>
                  <div class="history-info">
                    <span class="history-type">{{ item.orderStatusText }}</span>
                    <div class="history-meta">
                      <span class="history-date">{{ item.updateTimeText }}</span>
                    </div>
                  </div>
                  <div class="history-actions">
                    <el-button size="mini" circle @click="playVideo(item)">
                      <i class="el-icon-video-play"></i>
                    </el-button>
                    <el-button size="mini" circle @click="downloadVideo(item)">
                      <i class="el-icon-download"></i>
                    </el-button>
                  </div>
                </div>

                <!-- 空状态 -->
                <div v-if="!historyLoading && generationHistory.length === 0" class="history-empty">
                  <i class="el-icon-video-camera" style="font-size: 32px; color: #ccc;"></i>
                  <p>暂无生成记录</p>
                </div>
              </div>

              <!-- 分页 -->
              <div v-if="historyPagination.totalCount > 0" class="history-pagination">
                <el-pagination
                  @current-change="handleHistoryPageChange"
                  :current-page="historyPagination.current_page"
                  :page-size="historyPagination.pageSize"
                  :total="historyPagination.totalCount"
                  layout="prev, pager, next"
                  small
                />
              </div>
            </div>
          </div>
          </div>
        </div>

        <!-- 数字人管理内容 -->
        <div class="management-section" v-show="activeTab === 'manage'">
          <div class="management-header">
            <h3 class="management-title">我的定制数字人</h3>
            <el-button type="primary" class="create-digital-human-btn" @click="showCreatePersonDialogMethod">
              创建数字人
            </el-button>
          </div>

          <!-- 数字人列表 -->
          <div class="digital-human-grid" v-loading="myPersonLoading">
            <!-- 数字人卡片 -->
            <div class="digital-human-card" v-for="human in myPersonList" :key="human.personGuid">
              <div class="card-image">
                <!-- 使用 picUrl 作为封面图 -->
                <el-image
                  v-if="human.picUrl"
                  :src="human.picUrl"
                  fit="cover"
                  class="human-image"
                >
                  <div slot="placeholder" class="image-placeholder">
                    <i class="el-icon-loading"></i>
                  </div>
                  <div slot="error" class="image-placeholder">
                    <i class="el-icon-user-solid" style="font-size: 48px; color: #ccc;"></i>
                  </div>
                </el-image>
                <div v-else class="image-placeholder">
                  <i class="el-icon-user-solid" style="font-size: 48px; color: #ccc;"></i>
                </div>

                <!-- 状态标签 -->
                <div class="status-badge" :class="getPersonStatusClass(human)">
                  {{ getPersonStatusText(human) }}
                  <span v-if="human.progress !== undefined && human.progress < 100"> {{ human.progress }}%</span>
                </div>
              </div>

              <div class="card-content">
                <h4 class="card-title">{{ human.personName }}</h4>

                <!-- 训练类型和语言信息 -->
                <!-- <div class="card-info">
                  <span class="info-item" v-if="human.trainTypeText">{{ human.trainTypeText }}</span>
                  <span class="info-item" v-if="human.languageText">{{ human.languageText }}</span>
                </div> -->

                <!-- 使用次数 -->
                <div class="card-meta">
                  <span class="usage-count">使用次数: {{ human.useCount || 0 }}</span>
                </div>

                <!-- 操作按钮 -->
                <div class="card-actions">
                  <el-button size="small" @click="editDigitalHuman(human)">编辑</el-button>
                  <el-button
                    type="primary"
                    size="small"
                    @click="useDigitalHuman(human)"
                    :disabled="!isPersonAvailable(human)"
                  >
                    使用
                  </el-button>
                </div>
              </div>
            </div>

            <!-- 空状态 -->
            <div v-if="!myPersonLoading && myPersonList.length === 0" class="empty-state-container">
              <div class="empty-state">
                <div class="empty-icon">
                  <i class="el-icon-user-solid"></i>
                </div>
                <h3 class="empty-title">暂无数据</h3>
              </div>
            </div>
          </div>

          <!-- 分页 -->
          <!-- <div v-if="getCurrentPagination().totalCount > 0" class="pagination-wrapper">
            <el-pagination
              @current-change="handleAvatarPageChange"
              :current-page="getCurrentPagination().current_page"
              :page-size="getCurrentPagination().pageSize"
              :total="getCurrentPagination().totalCount"
              layout="prev, pager, next, jumper"
            />
          </div> -->
          <div class="pagination-container" v-if="myPersonPagination.totalCount > 0">
            <el-pagination
              @current-change="handleMyPersonPageChange"
              :current-page="myPersonPagination.current_page"
              :page-size="myPersonPagination.pageSize"
              :total="myPersonPagination.totalCount"
              layout="prev, pager, next, jumper"
              background
            />
          </div>
        </div>

        <!-- 音色训练内容 -->
        <div class="voice-training-section" v-show="activeTab === 'voice'">
          <div class="management-header">
            <h3 class="management-title">我的克隆声音</h3>
            <el-button type="primary" class="create-digital-human-btn" @click="openCreateAudioDialog">
              克隆声音
            </el-button>
          </div>

          <div class="fee-hint" v-if="pointsConfig">
            克隆声音收费：<b>{{ pointsConfig.cloneAudioPoints }}</b> 点/次
          </div>

          <div class="voice-grid" v-loading="audioListLoading">
            <div class="voice-card" v-for="a in myAudioList" :key="a.audioGuid">
              <div class="voice-card-head">
                <i class="el-icon-microphone voice-icon"></i>
                <div class="voice-info">
                  <div class="voice-name">{{ a.audioName }}</div>
                  <div class="voice-meta">
                    <span class="voice-lang">{{ a.languageText }}</span>
                    <span class="voice-status" :class="'vs-' + a.status">
                      {{ a.statusText }}<template v-if="a.status === 1 && a.progress"> {{ a.progress }}%</template>
                    </span>
                  </div>
                </div>
              </div>
              <div class="voice-err" v-if="a.errMsg">{{ a.errMsg }}</div>
              <div class="voice-card-actions">
                <digital-human-audio-preview v-if="a.audioPath" :src="a.audioPath" class="voice-audio" />
                <span v-else class="voice-audio-placeholder">训练完成后可试听</span>
                <el-button type="text" size="mini" class="voice-del" @click="handleDeleteAudio(a)">删除</el-button>
              </div>
            </div>

            <div v-if="!audioListLoading && myAudioList.length === 0" class="empty-state-container">
              <div class="empty-state">
                <div class="empty-icon"><i class="el-icon-microphone"></i></div>
                <h3 class="empty-title">还没有克隆声音，点击右上角「克隆声音」开始</h3>
              </div>
            </div>
          </div>

          <div class="pagination-container" v-if="audioPagination.totalCount > 0">
            <el-pagination
              @current-change="handleAudioPageChange"
              :current-page="audioPagination.current_page"
              :page-size="audioPagination.pageSize"
              :total="audioPagination.totalCount"
              layout="prev, pager, next, jumper"
              background
            />
          </div>
        </div>
      </el-main>
    </el-container>

    <!-- 数字人形象选择对话框 -->
    <el-dialog
      title="选择数字人形象"
      :visible.sync="showAvatarSelector"
      width="800px"
      class="avatar-selector-dialog"
    >
      <div class="dialog-tabs">
        <el-button
          :type="activeAvatarTab === 'template' ? 'primary' : 'default'"
          class="tab-btn"
          :class="{ active: activeAvatarTab === 'template' }"
          @click="switchAvatarTab('template')"
        >
          模板数字人
        </el-button>
        <el-button
          :type="activeAvatarTab === 'custom' ? 'primary' : 'default'"
          class="tab-btn"
          :class="{ active: activeAvatarTab === 'custom' }"
          @click="switchAvatarTab('custom')"
        >
          我的定制
        </el-button>
      </div>

      <div class="avatar-content">
        <div class="avatar-header">
          <span class="avatar-category">
            {{ activeAvatarTab === 'template' ? '模板数字人形象' : '我的定制数字人' }}
          </span>
          <span class="avatar-count">
            共 {{ activeAvatarTab === 'template' ? avatarPagination.totalCount : customAvatarPagination.totalCount }} 个数字人
          </span>
        </div>

        <digital-human-avatar-grid v-loading="loading" :avatars="getCurrentAvatarList()" :value="selectedAvatar"
          :empty-text="getCurrentEmptyText()" @select="selectAvatar" />
        <!-- 分页 -->
        <div v-if="getCurrentPagination().totalCount > 0" class="pagination-wrapper">
          <el-pagination
            @current-change="handleAvatarPageChange"
            :current-page="getCurrentPagination().current_page"
            :page-size="getCurrentPagination().pageSize"
            :total="getCurrentPagination().totalCount"
            layout="prev, pager, next, jumper"
          />
        </div>
      </div>
    </el-dialog>

    <!-- 创建数字人弹窗 -->
    <el-dialog
      :visible.sync="showCreatePersonDialog"
      width="500px"
      :show-header="false"
      custom-class="create-person-dialog"
      @close="resetCreateForm"
    >
      <div class="create-person-content">
        <h3 class="dialog-title">请上传您的视频完成数字人制作</h3>

        <div class="requirements-section">
          <h4 class="section-title">录制时可以这样做，效果会更好：</h4>
          <ul class="requirements-list">
            <li>• 全程脸部面朝相机，效果会更好。</li>
            <li>• 身体脸部朝前，不要侧对相机。</li>
          </ul>
        </div>

        <div class="requirements-section">
          <h4 class="section-title">时长，用词方面，停顿1s</h4>
          <p class="requirement-text">
            录制时间必须不少于10秒。建议先跟着几段对应的文案，先说一个停顿，然后可再讲解比较多素材，跟剪机器人一起作录制。
          </p>
        </div>

        <div class="requirements-section">
          <h4 class="section-title">清晰，用词方面，停顿1s</h4>
          <p class="requirement-text">
            录制画面必须不少于制到脸大，必须为画面拍摄应该为头像，制作数字的合成数字应该清楚用法，不能够录制模糊画面的。
          </p>
        </div>

        <!-- 视频上传区域 -->
        <div class="upload-section">
          <el-upload
            ref="videoUpload"
            name="video"
            :action="`${config.baseUrl}user/api.userinfo/uploadVideo`"
            :before-upload="beforeVideoUpload"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :on-progress="handleUploadProgress"
            :show-file-list="false"
            accept="video/*"
            :disabled="uploadLoading"
          >
            <div class="upload-area" :class="{ 'uploading': uploadLoading }">
              <div v-if="!uploadLoading && !uploadedVideoUrl" class="upload-placeholder">
                <i class="el-icon-video-camera" style="font-size: 48px; color: #4285f4;"></i>
                <p class="upload-text">点击上传视频</p>
                <p class="upload-hint">支持 MP4格式</p>
              </div>

              <div v-if="uploadLoading" class="upload-progress">
                <el-progress
                  type="circle"
                  :percentage="uploadProgress"
                  :width="80"
                  :stroke-width="6"
                >
                  <span class="progress-text">{{ uploadProgress }}%</span>
                </el-progress>
                <p class="upload-status">正在上传视频...</p>
              </div>

              <div v-if="uploadedVideoUrl && !uploadLoading" class="upload-success">
                <i class="el-icon-success" style="font-size: 48px; color: #67c23a;"></i>
                <p class="success-text">视频上传成功</p>
                <el-button size="small" type="text" @click="resetUpload">重新上传</el-button>
              </div>
            </div>
          </el-upload>
        </div>

        <!-- 数字人信息表单 -->
        <div class="person-form" v-if="uploadedVideoUrl">
          <el-form :model="createPersonForm" label-width="80px">
            <el-form-item label="名称" required>
              <el-input
                v-model="createPersonForm.name"
                placeholder="请输入数字人名称"
                maxlength="20"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="描述">
              <el-input
                type="textarea"
                v-model="createPersonForm.description"
                placeholder="请输入数字人描述（可选）"
                :rows="3"
                maxlength="200"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="训练类型">
              <el-radio-group v-model="createPersonForm.trainType" size="small">
                <el-radio-button label="both">形象+声音</el-radio-button>
                <el-radio-button label="figure">仅形象</el-radio-button>
                <el-radio-button label="voice">仅声音</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="语种">
              <el-radio-group v-model="createPersonForm.language" size="small">
                <el-radio-button label="cn">中文</el-radio-button>
                <el-radio-button label="en">英文</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="清晰度">
              <el-radio-group v-model="createPersonForm.resolutionRate" size="small">
                <el-radio-button :label="0">1080P</el-radio-button>
                <el-radio-button :label="1">4K</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="移除背景">
              <el-switch v-model="createPersonForm.isRemoveBg"></el-switch>
              <span class="form-hint">开启后可在生成视频时更换背景</span>
            </el-form-item>
            <el-form-item label="高质量">
              <el-switch v-model="createPersonForm.isHighQuality"></el-switch>
            </el-form-item>
            <el-form-item label="版本">
              <el-radio-group v-model="createPersonForm.version" size="small">
                <el-radio-button label="1.0">1.0</el-radio-button>
                <el-radio-button label="2.0">2.0（需授权）</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <template v-if="createPersonForm.version === '2.0'">
              <el-form-item label="授权视频">
                <el-upload
                  name="video"
                  :action="`${config.baseUrl}user/api.userinfo/uploadVideo`"
                  :data="{ merchant_guid: $store.state.merchantGuid }"
                  :show-file-list="false"
                  accept="video/*"
                  :before-upload="beforeAuthVideoUpload"
                  :on-success="handleAuthVideoSuccess"
                  :on-error="() => { authVideoUploading = false; $message.error('授权视频上传失败'); }"
                >
                  <el-button size="small" :loading="authVideoUploading">
                    {{ createPersonForm.authVideoUrl ? '已上传，点击重传' : '上传授权视频' }}
                  </el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="授权文案">
                <el-input
                  type="textarea"
                  v-model="createPersonForm.authText"
                  placeholder="请输入授权文案"
                  :rows="2"
                  maxlength="500"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </template>
          </el-form>
          <div class="fee-hint" v-if="pointsConfig">
            克隆形象收费：<b>{{ pointsConfig.clonePersonPoints }}</b> 点/次
          </div>
        </div>

        <div class="dialog-actions">
          <el-button
            type="primary"
            class="upload-btn"
            @click="handleCreatePerson"
            :loading="createLoading"
            :disabled="!uploadedVideoUrl || !createPersonForm.name.trim()"
          >
            {{ createLoading ? '创建中...' : '创建' }}
          </el-button>
          <el-button class="cancel-btn" @click="closeCreatePersonDialog">
            取消
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 视频生成进度弹窗 -->
    <el-dialog
      :visible.sync="progressDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="progressData.status !== 'processing'"
      center
      :show-header="false"
      custom-class="progress-dialog"
    >
      <div class="progress-dialog-content">
        <!-- 数字人头像 -->
        <div class="avatar-container">
          <el-image
            :src="progressData.avatarImage"
            fit="cover"
            class="avatar-image"
          >
            <div slot="placeholder" class="avatar-placeholder">
              <i class="el-icon-user" style="font-size: 40px; color: #ccc;"></i>
            </div>
          </el-image>
        </div>

        <!-- 播放图标 -->
        <div class="play-icon-container">
          <div class="play-icon">
            <i class="el-icon-video-play" style="font-size: 24px; color: white;"></i>
          </div>
        </div>

        <!-- 进度信息 -->
        <div class="progress-info">
          <div class="progress-text">视频正在制作中{{ Math.round(progressData.progress) }}%</div>

          <!-- 进度条 -->
          <div class="progress-bar-container">
            <div class="progress-bar">
              <div
                class="progress-bar-fill"
                :style="{ width: progressData.progress + '%' }"
              ></div>
            </div>
          </div>

          <div class="progress-message">{{ progressData.message }}</div>
        </div>

        <!-- 操作按钮 -->
        <div class="progress-actions" v-if="progressData.status !== 'processing'">
          <el-button v-if="progressData.status === 'success'" type="primary" @click="handleProgressSuccess">
            查看生成记录
          </el-button>
          <el-button v-if="progressData.status === 'failed'" type="danger" @click="handleProgressFailed">
            重新生成
          </el-button>
          <el-button @click="closeProgressDialog">关闭</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 克隆声音弹窗 -->
    <el-dialog
      title="克隆声音"
      :visible.sync="showCreateAudioDialog"
      width="480px"
      custom-class="create-audio-dialog"
      @close="resetCreateAudioForm"
    >
      <div class="create-audio-content">
        <p class="audio-tip">上传一段清晰的人声音频（建议 10 秒以上、无背景噪音），用于克隆专属音色。</p>

        <el-upload
          class="audio-uploader"
          :action="`${config.baseUrl}user/api.userinfo/uploadVoice`"
          :data="{ merchant_guid: $store.state.merchantGuid }"
          name="voice"
          accept="audio/*"
          :show-file-list="false"
          :before-upload="beforeAudioUpload"
          :on-success="handleAudioUploadSuccess"
          :on-error="handleAudioUploadError"
        >
          <div class="audio-upload-box" v-loading="audioUploading">
            <template v-if="createAudioForm.audioUrl">
              <i class="el-icon-success" style="color:#67c23a;font-size:28px;"></i>
              <span>音频已上传，点击可重新上传</span>
              <audio :src="createAudioForm.audioUrl" controls class="audio-preview" @click.stop></audio>
            </template>
            <template v-else>
              <i class="el-icon-upload2" style="font-size:28px;color:#7848f1;"></i>
              <span>点击上传音频（mp3/wav/m4a）</span>
            </template>
          </div>
        </el-upload>

        <el-form :model="createAudioForm" label-width="72px" class="audio-form">
          <el-form-item label="声音名称" required>
            <el-input v-model="createAudioForm.name" placeholder="给声音起个名字" maxlength="20" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="语种">
            <el-radio-group v-model="createAudioForm.language">
              <el-radio label="cn">中文</el-radio>
              <el-radio label="en">英文</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="示例文案">
            <el-input
              type="textarea"
              v-model="createAudioForm.text"
              :rows="2"
              placeholder="选填：音频对应的文本，有助于提升克隆质量"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="fee-hint" v-if="pointsConfig">
          本次克隆将消耗 <b>{{ pointsConfig.cloneAudioPoints }}</b> 点
        </div>

        <div class="dialog-actions">
          <el-button
            type="primary"
            :loading="createAudioLoading"
            :disabled="!createAudioForm.audioUrl || !createAudioForm.name.trim()"
            @click="handleCreateAudio"
          >
            {{ createAudioLoading ? '提交中...' : '开始克隆' }}
          </el-button>
          <el-button @click="showCreateAudioDialog = false">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import {
  commonPersonListApi,
  worksListApi,
  getMyPersonListApi,
  createVideoTaskApi,
  getVideoDetailApi,
  createPersonkApi,
  getPointsConfigApi,
  calculatePointsApi,
  createCustomAudioApi,
  getMyAudioListApi,
  deleteAudioApi
} from '@/apis/human'
import config from '@/apis/config'
import DigitalHumanAvatarGrid from './components/digital-human-avatar-grid.vue'
import DigitalHumanAudioPreview from './components/digital-human-audio-preview.vue'

export default {
  name: 'LayoutDigitalHuman',
  components: { DigitalHumanAvatarGrid, DigitalHumanAudioPreview },
  data() {
    return {
      config: config, // 添加 config 到 data 中，以便在模板中使用
      activeTab: 'generate', // 当前激活的Tab
      inputText: '',
      generating: false,
      selectedAvatar: 1,

      // 背景设置（选填）。仅 isSupportRemoveBg 的形象可用
      bgSrcUrl: '',
      bgUploading: false,

      // 收费配置与预估
      pointsConfig: null,
      estimateInfo: null,

      // 视频高级参数
      showAdvanced: false,
      videoParams: {
        resolutionRate: 0,   // 0:1080p 1:4k
        model: 0,            // 0:基础版 1:高质版
        backway: 1,          // 1正放 2倒放
        personX: 0,          // 人物水平偏移
        personY: 480,        // 人物垂直偏移
        subtitleShow: false, // 显示字幕
        addComplianceWatermark: false, // 合规水印
      },

      // TTS 音色选择（''=形象自带音色，否则为「我的克隆声音」chanjingAudioId）
      selectedVoiceId: '',

      // 音色训练（克隆声音）
      myAudioList: [],
      audioListLoading: false,
      audioPagination: {
        current_page: 1,
        pageSize: 12,
        totalCount: 0,
      },
      showCreateAudioDialog: false,
      audioUploading: false,
      createAudioLoading: false,
      audioPollTimer: null,
      createAudioForm: {
        name: '',
        language: 'cn',
        audioUrl: '',
        text: '',
      },

      // 进度弹窗相关
      progressDialogVisible: false,
      currentTaskId: null,
      progressData: {
        progress: 0,
        status: 'processing', // processing, success, failed
        title: '',
        message: '您的作品正在精心打磨中',
        avatarImage: null
      },
      progressTimer: null,
      showCreateDialog: false,
      showCreatePersonDialog: false,
      showAvatarSelector: false,
      activeAvatarTab: 'template',
      loading: false,
      historyLoading: false,
      myPersonLoading: false,
      createForm: {
        name: '',
        description: ''
      },

      // 创建数字人相关（全参）
      createPersonForm: {
        name: '',
        description: '',
        trainType: 'both',      // voice/figure/both
        language: 'cn',         // cn/en
        isRemoveBg: false,      // 支持移除背景
        isHighQuality: false,   // 高质量
        resolutionRate: 0,      // 0:1080p 1:4k
        version: '1.0',         // 1.0 / 2.0(需授权视频+文案)
        authText: '',           // 2.0 授权文案
        authVideoUrl: '',       // 2.0 授权视频
      },
      authVideoUploading: false,
      uploadLoading: false,
      createLoading: false,
      uploadProgress: 0,
      uploadedVideoUrl: '',
      avatars: [
        { id: 1, name: '时尚女性' },
        { id: 2, name: '商务男性' },
        { id: 3, name: '休闲女性' }
      ],
      templateAvatars: [],
      myCustomAvatars: [], // 我的定制数字人列表
      myPersonList: [], // 我的数字人列表

      // 数字人分页
      avatarPagination: {
        current_page: 1,
        pageSize: 10,
        totalCount: 0,
      },

      // 我的定制数字人分页
      customAvatarPagination: {
        current_page: 1,
        pageSize: 10,
        totalCount: 0,
      },

      // 我的数字人分页
      myPersonPagination: {
        current_page: 1,
        pageSize: 10,
        totalCount: 0,
      },

      // 生成记录分页
      historyPagination: {
        current_page: 1,
        pageSize: 10,
        totalCount: 0,
      },
      generationHistory: [],
      digitalHumans: [
        {
          id: 1,
          name: '我的专属数字人1',
          usageCount: 8,
          status: 'active',
          statusText: '活跃'
        },
        {
          id: 2,
          name: '我的专属数字人2',
          usageCount: 0,
          status: 'training',
          statusText: '训练中'
        },
        {
          id: 3,
          name: '我的专属数字人3',
          usageCount: 12,
          status: 'active',
          statusText: '活跃'
        },
        {
          id: 4,
          name: '我的专属数字人4',
          usageCount: 5,
          status: 'inactive',
          statusText: '未激活'
        }
      ]
    }
  },
  computed: {
    // 当前选中的形象对象（模板/定制通用）
    currentAvatarInfo() {
      return this.templateAvatars.find(a => a.id === this.selectedAvatar) ||
             this.myCustomAvatars.find(a => a.id === this.selectedAvatar) ||
             null;
    },
    // 蝉镜要求：背景仅在移除形象原背景后生效，而这只对部分形象可用
    canSetBackground() {
      return !!(this.currentAvatarInfo && this.currentAvatarInfo.isSupportRemoveBg);
    },
    // 背景图推荐尺寸，跟随当前形象画布
    bgRecommendSize() {
      const figure = this.currentAvatarInfo && this.currentAvatarInfo.figures
        ? this.currentAvatarInfo.figures[0]
        : null;
      const width = (figure && figure.width) || 1080;
      const height = (figure && figure.height) || 1920;
      return `${width}×${height}`;
    },
    // 可用于配音的「我的克隆声音」（训练成功且有蝉镜ID）
    availableAudioOptions() {
      return (this.myAudioList || []).filter(a => a.isAvailable && a.chanjingAudioId);
    },
  },
  async mounted() {
    await this.getPersonList();
    await this.getGenerationHistory();
    await this.getMyPersonList();
    this.fetchPointsConfig();
    this.getMyAudioList();
  },
  beforeDestroy() {
    // 清理定时器
    this.clearProgressTimer();
    this.clearAudioPolling();
    if (this._estimateTimer) clearTimeout(this._estimateTimer);
  },
  watch: {
    // 文本变化后防抖预估算力
    inputText() {
      if (this._estimateTimer) clearTimeout(this._estimateTimer);
      this._estimateTimer = setTimeout(() => this.estimatePoints(), 600);
    },
  },
  methods: {
    // 获取数字人列表
    async getPersonList(page = 1) {
      try {
        this.loading = true;
        const response = await commonPersonListApi({
          page: page,
          pageSize: this.avatarPagination.pageSize
        });
        if(response.code === 0){
          this.templateAvatars = response.data.list || [];
          // 更新分页信息
          this.avatarPagination = {
            current_page: response.data.pageInfo.current_page || page,
            pageSize: response.data.pageInfo.pageSize || this.avatarPagination.pageSize,
            totalCount: response.data.pageInfo.totalCount || 0,
          };
          this.updateAvatarCount();
        }else{
          // 接口失败（如蝉镜密钥失效/欠费）：清空列表并把后端错误透出，不要静默
          this.templateAvatars = [];
          this.$message.error(response.msg || '获取数字人形象失败，请稍后再试');
        }
      } catch (error) {
        console.error('获取数字人列表失败:', error);
        this.templateAvatars = [];
        this.$message.error('获取数字人形象失败，请稍后再试');
      } finally {
        this.loading = false;
      }
    },
    // 更新数字人数量显示
    updateAvatarCount() {
      // 如果有数字人数据，设置默认选中第一个
      if (this.templateAvatars.length > 0) {
        // 如果当前没有选中的，或者选中的不在当前列表中，则选中第一个
        const currentExists = this.templateAvatars.find(a => a.id === this.selectedAvatar);
        if (!currentExists) {
          this.selectedAvatar = this.templateAvatars[0].id;
        }
      }
    },

    // 获取生成记录
    async getGenerationHistory(page = 1) {
      try {
        this.historyLoading = true;

        const params = {
          page: page,
          pageSize: this.historyPagination.pageSize
        };

        const response = await worksListApi(params);

        if (response && response.code === 0 && response.data) {
          // 处理返回的数据，适配显示格式
          this.generationHistory = response.data.list

          this.historyPagination = {
            current_page: response.data.pageInfo.current_page || page,
            pageSize: response.data.pageInfo.pageSize || this.historyPagination.pageSize,
            totalCount: response.data.pageInfo.totalCount || 0,
          };
        }
      } catch (error) {
        console.error('获取生成记录失败:', error);
      } finally {
        this.historyLoading = false;
      }
    },

    // 映射作品状态
    mapWorkStatus(status) {
      const statusMap = {
        0: 'processing', // 处理中
        1: 'completed',  // 已完成
        2: 'failed',     // 失败
        3: 'pending'     // 等待中
      };
      return statusMap[status] || 'processing';
    },

    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '未知时间';

      const date = new Date(dateStr);
      const now = new Date();
      const diff = now - date;

      const minutes = Math.floor(diff / (1000 * 60));
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));

      if (minutes < 60) {
        return `${minutes}分钟前`;
      } else if (hours < 24) {
        return `${hours}小时前`;
      } else if (days < 7) {
        return `${days}天前`;
      } else {
        return date.toLocaleDateString();
      }
    },

    // 数字人分页处理
    async handleAvatarPageChange(page) {
      if (this.activeAvatarTab === 'template') {
        this.avatarPagination.current_page = page;
        await this.getPersonList(page);
      } else {
        this.customAvatarPagination.current_page = page;
        await this.getMyCustomAvatars(page);
      }
    },

    // 获取我的定制数字人列表
    async getMyCustomAvatars(page = 1) {
      try {
        this.loading = true;
        const params = {
          page: page,
          pageSize: this.customAvatarPagination.pageSize
        };

        const response = await getMyPersonListApi(params);

        if (response && response.code === 0 && response.data) {
          this.myCustomAvatars = response.data.list || [];
          this.customAvatarPagination = {
            current_page: response.data.current_page || page,
            pageSize: response.data.pageSize || this.customAvatarPagination.pageSize,
            totalCount: response.data.pageInfo.totalCount || 0,
          };
        }
      } catch (error) {
        console.error('获取我的定制数字人列表失败:', error);
        this.myCustomAvatars = [];
      } finally {
        this.loading = false;
      }
    },

    // 生成记录分页处理
    async handleHistoryPageChange(page) {
      this.historyPagination.current_page = page;
      await this.getGenerationHistory(page);
    },

    // 获取当前选中的数字人名称
    getCurrentAvatarName() {
      const currentAvatar = this.templateAvatars.find(a => a.id === this.selectedAvatar) ||
                           this.myCustomAvatars.find(a => a.id === this.selectedAvatar);
      return currentAvatar ? currentAvatar.name : '';
    },

    // 获取当前选中数字人的图片
    getCurrentAvatarImage() {
      const currentAvatar = this.templateAvatars.find(a => a.id === this.selectedAvatar) ||
                           this.myCustomAvatars.find(a => a.id === this.selectedAvatar);
      return currentAvatar ? this.getTemplateImage(currentAvatar) : '';
    },

    // 获取当前分页信息
    getCurrentPagination() {
      return this.activeAvatarTab === 'template' ? this.avatarPagination : this.customAvatarPagination;
    },

    // 获取当前数字人列表
    getCurrentAvatarList() {
      return this.activeAvatarTab === 'template' ? this.templateAvatars : this.myCustomAvatars;
    },

    // 获取当前空状态文本
    getCurrentEmptyText() {
      return this.activeAvatarTab === 'template' ? '暂无模板数字人形象' : '暂无定制数字人形象';
    },

    switchTab(tab) {
      this.activeTab = tab;
      if (tab === 'voice') {
        this.getMyAudioList();
      }
    },

    // 切换数字人类型
    switchAvatarTab(tab) {
      this.activeAvatarTab = tab;
      if (tab === 'custom' && this.myCustomAvatars.length === 0) {
        // 如果切换到我的定制但还没有数据，重新获取
        this.getMyCustomAvatars();
      }
    },
    async generateVideo() {
      if (!this.inputText.trim()) {
        this.$message.warning('请输入文本内容');
        return;
      }

      if (!this.selectedAvatar) {
        this.$message.warning('请选择数字人形象');
        return;
      }

      this.generating = true;

      try {
        // 获取当前选中的数字人信息
        const currentAvatar = this.templateAvatars.find(a => a.id === this.selectedAvatar) ||
                             this.myCustomAvatars.find(a => a.id === this.selectedAvatar);

        if (!currentAvatar) {
          this.$message.error('未找到选中的数字人信息');
          return;
        }

        // 根据不同类型获取不同字段进行传递
        const createParams = {
            text: this.inputText.trim(),
            audioType: 'tts', // 默认音频类型
          }
        let previewUrl = '';
        if (this.activeAvatarTab === 'template') {
          // 模板数字人数据结构
          createParams.personId = currentAvatar.id;
          createParams.audioManId = currentAvatar.audioManId;
          createParams.figureType = currentAvatar.figures?.[0]?.type;
          createParams.personName = currentAvatar.name;
			    previewUrl = currentAvatar.figures[0]?.cover

        } else {
          // 定制数字人数据结构
          createParams.personId = currentAvatar.chanjingPersonId;
          createParams.audioManId = currentAvatar.audioManId;
          createParams.figureType = '';
          createParams.personName = currentAvatar.name;
			    previewUrl = currentAvatar.picUrl
        }

        // 背景为选填，且只有支持移除原背景的形象能用；
        // 不满足条件时不下发，避免服务端收到无效参数
        if (this.canSetBackground && this.bgSrcUrl) {
          createParams.isRemoveBg = true;
          createParams.bgSrcUrl = this.bgSrcUrl;
        }

        if (previewUrl) {
          // 获取图片宽高
          try {
            const dimensions = await this.getImageDimensions(previewUrl);
            createParams.personWidth = dimensions.width;
            createParams.personHeight = dimensions.height;
          } catch (error) {
            console.error('获取图片尺寸失败:', error);
            // 设置默认尺寸
            createParams.personWidth = 1080;
            createParams.personHeight = 1440;
          }
        }

        // 高级参数（清晰度/画质/正反播/偏移/字幕/水印）
        createParams.resolutionRate = this.videoParams.resolutionRate;
        createParams.model = this.videoParams.model;
        createParams.backway = this.videoParams.backway;
        createParams.personX = this.videoParams.personX;
        createParams.personY = this.videoParams.personY;
        createParams.subtitleShow = this.videoParams.subtitleShow;
        createParams.addComplianceWatermark = this.videoParams.addComplianceWatermark;

        // 自定义配音音色：选择「我的克隆声音」时覆盖形象自带音色
        if (this.selectedVoiceId) {
          createParams.audioManId = this.selectedVoiceId;
        }

        const response = await createVideoTaskApi(createParams);

        if (response && response.code === 0) {
          // 获取当前选中数字人的头像
          const avatarImage = this.getTemplateImage(currentAvatar);

          // 显示进度弹窗
          this.showProgressDialog(response.data.orderNo, createParams.text, avatarImage);

          // 清空输入框
          this.inputText = '';
        } else {
          this.$message.error(response.msg || '视频生成失败，请重试');
        }
      } catch (error) {
        console.error('视频生成失败:', error);
        this.$message.error('视频生成失败，请重试');
      } finally {
        this.generating = false;
      }
    },
    selectAvatar(id) {
      this.selectedAvatar = id;
      // 新形象不支持换背景时清掉已选背景图，避免用户误以为背景仍会生效
      if (!this.canSetBackground) {
        this.bgSrcUrl = '';
      }
    },
    playVideo(item) {
      // 跳转到视频播放页面，传入orderNo
      const routeData = this.$router.resolve({
        path: '/video-player',
        query: { orderNo: item.orderNo || item.id }
      });
      window.open(routeData.href, '_blank');
    },
    downloadVideo(item) {
      // 跳转到视频播放页面，传入orderNo
      const routeData = this.$router.resolve({
        path: '/video-player',
        query: { orderNo: item.orderNo || item.id }
      });
      window.open(routeData.href, '_blank');
    },
    createDigitalHuman() {
      if (!this.createForm.name.trim()) {
        this.$message.warning('请输入数字人名称');
        return;
      }

      // 添加新的数字人到列表
      this.digitalHumans.push({
        id: Date.now(),
        name: this.createForm.name,
        usageCount: 0,
        status: 'training',
        statusText: '训练中'
      });

      this.$message.success('数字人创建成功！');
      this.showCreateDialog = false;
      this.createForm = { name: '', description: '' };
    },

    // 进度弹窗相关方法
    showProgressDialog(taskId, title, avatarImage) {
      this.currentTaskId = taskId;
      this.progressData = {
        progress: 0,
        status: 'processing',
        message: '您的作品正在精心打磨中',
        title: title.substring(0, 20) + (title.length > 20 ? '...' : ''),
        avatarImage: avatarImage
      };
      this.progressDialogVisible = true;
      this.startProgressPolling();
    },

    async startProgressPolling() {
      // 使用真实API查询进度
      this.progressTimer = setInterval(async () => {
        try {
          const response = await getVideoDetailApi({ orderNo: this.currentTaskId });

          if (response && response.code === 0) {
            const data = response.data;

            // 更新进度
            this.progressData.progress = data.progress || 0;

            // 判断是否成功：进度>=100 或 status=30
            if (this.progressData.progress >= 100 || data.status === 30) {
              this.progressData.progress = 100;
              this.progressData.status = 'success';
              this.progressData.message = '视频生成完成！';
              this.clearProgressTimer();

              // 刷新生成记录
              setTimeout(() => {
                this.getGenerationHistory();
              }, 1000);
            } else if (data.status === 'failed' || data.status === 'error') {
              this.progressData.status = 'failed';
              this.progressData.message = data.message || '视频生成失败，请重试';
              this.clearProgressTimer();
            } else {
              // 处理中状态
              this.progressData.status = 'processing';
            }
          }
        } catch (error) {
          console.error('查询进度失败:', error);
          // 如果API调用失败，可以选择继续轮询或停止
        }
      }, 3000); // 每3秒查询一次
    },

    clearProgressTimer() {
      if (this.progressTimer) {
        clearInterval(this.progressTimer);
        this.progressTimer = null;
      }
    },

    getProgressColor() {
      if (this.progressData.status === 'success') {
        return '#67C23A';
      } else if (this.progressData.status === 'failed') {
        return '#F56C6C';
      } else {
        return '#409EFF';
      }
    },

    handleProgressSuccess() {
      this.closeProgressDialog();
      // 可以跳转到生成记录tab或滚动到生成记录区域
      this.$message.success('请查看生成记录中的最新视频');
    },

    handleProgressFailed() {
      this.closeProgressDialog();
      // 重新生成逻辑
      this.$message.info('请重新尝试生成视频');
    },

    closeProgressDialog() {
      this.progressDialogVisible = false;
      this.clearProgressTimer();
      this.currentTaskId = null;
    },
    editDigitalHuman(human) {
      this.$message.info('编辑数字人: ' + human.name);
    },
    useDigitalHuman(human) {
      if (human.status === 'training') {
        this.$message.warning('数字人正在训练中，请稍后再试');
        return;
      }
      if (human.status === 'inactive') {
        this.$message.warning('数字人未激活，请先激活');
        return;
      }

      // 切换到视频生成Tab并选择该数字人
      this.activeTab = 'generate';
      this.$message.success('已选择数字人: ' + human.name);
    },
    // 获取模板图片
    getTemplateImage(template) {
      if (this.activeAvatarTab === 'template') {
        // 定制数字人数据结构：figures[0].cover
        return template.figures?.[0]?.cover
      } else {
        // 模板数据结构：picUrl
        return template.picUrl
      }
    },

    // 获取图片尺寸
    getImageDimensions(imageUrl) {
      return new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = function() {
          resolve({
            width: this.naturalWidth,
            height: this.naturalHeight
          });
        };

        img.onerror = function() {
          reject(new Error('图片加载失败'));
        };

        // 设置跨域属性（如果需要）
        img.crossOrigin = 'anonymous';
        img.src = imageUrl;
      });
    },

    // 获取我的数字人列表
    async getMyPersonList() {
      try {
        this.myPersonLoading = true;
        const response = await getMyPersonListApi({
          page: this.myPersonPagination.current_page,
          pageSize: this.myPersonPagination.pageSize
        });

        if (response && response.code === 0) {
          this.myPersonList = response.data.list || [];
          this.myPersonPagination.totalCount = response.data.pageInfo.totalCount || 0;
        } else {
          this.$message.error(response.msg || '获取数字人列表失败');
        }
      } catch (error) {
        console.error('获取数字人列表失败:', error);
        this.$message.error('获取数字人列表失败');
      } finally {
        this.myPersonLoading = false;
      }
    },

    // 我的数字人分页
    handleMyPersonPageChange(page) {
      this.myPersonPagination.current_page = page;
      this.getMyPersonList();
    },

    // 显示创建数字人弹窗
    showCreatePersonDialogMethod() {
      this.showCreatePersonDialog = true;
    },

    // 背景图上传前检查。蝉镜仅接受 jpg/png/heic，且要求 URL 保留扩展名
    beforeBgUpload(file) {
      const isImage = ['image/jpeg', 'image/png'].includes(file.type);
      const isLt20M = file.size / 1024 / 1024 < 20;

      if (!isImage) {
        this.$message.error('背景图只支持 JPG / PNG 格式!');
        return false;
      }
      if (!isLt20M) {
        this.$message.error('背景图大小不能超过 20MB!');
        return false;
      }

      this.bgUploading = true;
      return true;
    },

    // 背景图上传成功
    handleBgUploadSuccess(response) {
      this.bgUploading = false;

      if (response && response.code === 0) {
        this.bgSrcUrl = response.data;
        this.$message.success('背景图上传成功');
      } else {
        this.$message.error((response && response.msg) || '背景图上传失败');
      }
    },

    // 背景图上传失败
    handleBgUploadError() {
      this.bgUploading = false;
      this.$message.error('背景图上传失败，请重试');
    },

    // 移除已选背景图
    clearBackground() {
      this.bgSrcUrl = '';
    },

    // 上传前检查
    beforeVideoUpload(file) {
      const isVideo = file.type.startsWith('video/');
      const isLt100M = file.size / 1024 / 1024 < 100;

      if (!isVideo) {
        this.$message.error('只能上传视频文件!');
        return false;
      }
      if (!isLt100M) {
        this.$message.error('上传视频大小不能超过 100MB!');
        return false;
      }

      this.uploadLoading = true;
      this.uploadProgress = 0;
      return true;
    },

    // 上传进度
    handleUploadProgress(event) {
      this.uploadProgress = Math.round(event.percent);
    },

    // 上传成功
    handleUploadSuccess(response) {
      this.uploadLoading = false;
      this.uploadProgress = 100;

      console.log('上传成功响应:', response);

      if (response && response.code === 0) {
        this.uploadedVideoUrl = response.data;
        this.$message.success('视频上传成功');
      } else {
        this.$message.error(response.msg || '上传失败');
        this.uploadProgress = 0;
      }
    },

    // 上传失败
    handleUploadError(error) {
      this.uploadLoading = false;
      this.uploadProgress = 0;
      console.error('上传失败:', error);
      this.$message.error('视频上传失败，请重试');
    },

    // 重置上传
    resetUpload() {
      this.uploadedVideoUrl = '';
      this.uploadProgress = 0;
      this.authVideoUploading = false;
      this.createPersonForm = {
        name: '',
        description: '',
        trainType: 'both',
        language: 'cn',
        isRemoveBg: false,
        isHighQuality: false,
        resolutionRate: 0,
        version: '1.0',
        authText: '',
        authVideoUrl: '',
      };
    },

    // 授权视频上传前校验
    beforeAuthVideoUpload(file) {
      const isVideo = file.type.startsWith('video/');
      if (!isVideo) {
        this.$message.error('只能上传视频文件!');
        return false;
      }
      this.authVideoUploading = true;
      return true;
    },

    // 授权视频上传成功
    handleAuthVideoSuccess(response) {
      this.authVideoUploading = false;
      if (response && response.code === 0) {
        this.createPersonForm.authVideoUrl = response.data;
        this.$message.success('授权视频上传成功');
      } else {
        this.$message.error((response && response.msg) || '授权视频上传失败');
      }
    },

    // ==================== 收费配置与预估 ====================

    // 获取收费配置
    async fetchPointsConfig() {
      try {
        const response = await getPointsConfigApi({});
        if (response && response.code === 0 && response.data) {
          this.pointsConfig = response.data.config || null;
        }
      } catch (error) {
        console.error('获取算力配置失败:', error);
      }
    },

    // 预估本次生成消耗
    async estimatePoints() {
      const text = this.inputText.trim();
      if (!text) {
        this.estimateInfo = null;
        return;
      }
      try {
        const response = await calculatePointsApi({ audioType: 'tts', text });
        if (response && response.code === 0 && response.data) {
          this.estimateInfo = response.data.calculation || null;
        }
      } catch (error) {
        console.error('预估算力失败:', error);
      }
    },

    // ==================== 音色训练（克隆声音） ====================

    // 我的克隆声音列表
    async getMyAudioList(page = 1) {
      try {
        this.audioListLoading = true;
        const response = await getMyAudioListApi({
          page,
          pageSize: this.audioPagination.pageSize,
        });
        if (response && response.code === 0 && response.data) {
          this.myAudioList = response.data.list || [];
          this.audioPagination = {
            current_page: (response.data.pageInfo && response.data.pageInfo.page) || page,
            pageSize: (response.data.pageInfo && response.data.pageInfo.pageSize) || this.audioPagination.pageSize,
            totalCount: (response.data.pageInfo && response.data.pageInfo.totalCount) || 0,
          };
          // 有训练中的声音则轮询刷新
          this.scheduleAudioPolling();
        }
      } catch (error) {
        console.error('获取克隆声音列表失败:', error);
      } finally {
        this.audioListLoading = false;
      }
    },

    // 克隆声音分页
    handleAudioPageChange(page) {
      this.audioPagination.current_page = page;
      this.getMyAudioList(page);
    },

    // 训练中状态轮询（存在训练中项时每 10s 刷新一次，全部完成即停止）
    scheduleAudioPolling() {
      const hasPending = this.myAudioList.some(a => a.status === 1);
      if (!hasPending) {
        this.clearAudioPolling();
        return;
      }
      if (this.audioPollTimer) return;
      this.audioPollTimer = setInterval(() => {
        if (this.activeTab !== 'voice') return;
        this.getMyAudioList(this.audioPagination.current_page);
      }, 10000);
    },

    clearAudioPolling() {
      if (this.audioPollTimer) {
        clearInterval(this.audioPollTimer);
        this.audioPollTimer = null;
      }
    },

    // 打开克隆声音弹窗
    openCreateAudioDialog() {
      this.showCreateAudioDialog = true;
    },

    // 音频上传前校验
    beforeAudioUpload(file) {
      const isAudio = file.type.startsWith('audio/');
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isAudio) {
        this.$message.error('只能上传音频文件!');
        return false;
      }
      if (!isLt50M) {
        this.$message.error('音频大小不能超过 50MB!');
        return false;
      }
      this.audioUploading = true;
      return true;
    },

    // 音频上传成功（uploadVoice 返回 data.voiceUrl）
    handleAudioUploadSuccess(response) {
      this.audioUploading = false;
      if (response && response.code === 0 && response.data) {
        this.createAudioForm.audioUrl = response.data.voiceUrl || response.data;
        this.$message.success('音频上传成功');
      } else {
        this.$message.error((response && response.msg) || '音频上传失败');
      }
    },

    handleAudioUploadError() {
      this.audioUploading = false;
      this.$message.error('音频上传失败，请重试');
    },

    // 提交克隆声音
    async handleCreateAudio() {
      if (!this.createAudioForm.audioUrl) {
        this.$message.warning('请先上传音频');
        return;
      }
      if (!this.createAudioForm.name.trim()) {
        this.$message.warning('请输入声音名称');
        return;
      }
      try {
        this.createAudioLoading = true;
        const response = await createCustomAudioApi({
          audioName: this.createAudioForm.name.trim(),
          audioUrl: this.createAudioForm.audioUrl,
          language: this.createAudioForm.language,
          text: this.createAudioForm.text.trim(),
        });
        if (response && response.code === 0) {
          this.$message.success('已提交克隆，正在训练中...');
          this.showCreateAudioDialog = false;
          await this.getMyAudioList(1);
          this.fetchPointsConfig(); // 刷新余额
        } else {
          this.$message.error(response.msg || '克隆声音失败，请重试');
        }
      } catch (error) {
        console.error('克隆声音失败:', error);
        this.$message.error('克隆声音失败，请重试');
      } finally {
        this.createAudioLoading = false;
      }
    },

    // 删除克隆声音
    handleDeleteAudio(audio) {
      this.$confirm(`确定删除声音「${audio.audioName}」吗？`, '提示', {
        type: 'warning',
      }).then(async () => {
        try {
          const response = await deleteAudioApi({ audioGuid: audio.audioGuid });
          if (response && response.code === 0) {
            this.$message.success('删除成功');
            this.getMyAudioList(this.audioPagination.current_page);
          } else {
            this.$message.error(response.msg || '删除失败');
          }
        } catch (error) {
          console.error('删除克隆声音失败:', error);
          this.$message.error('删除失败');
        }
      }).catch(() => {});
    },

    // 重置克隆声音表单
    resetCreateAudioForm() {
      this.createAudioForm = { name: '', language: 'cn', audioUrl: '', text: '' };
      this.audioUploading = false;
    },

    // 创建数字人
    async handleCreatePerson() {
      if (!this.uploadedVideoUrl) {
        this.$message.warning('请先上传视频');
        return;
      }

      if (!this.createPersonForm.name.trim()) {
        this.$message.warning('请输入数字人名称');
        return;
      }

      // 2.0 版本需授权视频 + 授权文案
      if (this.createPersonForm.version === '2.0') {
        if (!this.createPersonForm.authVideoUrl) {
          this.$message.warning('2.0 版本需上传授权视频');
          return;
        }
        if (!this.createPersonForm.authText.trim()) {
          this.$message.warning('2.0 版本需填写授权文案');
          return;
        }
      }

      try {
        this.createLoading = true;

        const params = {
          personName: this.createPersonForm.name.trim(),
          description: this.createPersonForm.description.trim(),
          materialVideoUrl: this.uploadedVideoUrl,
          trainType: this.createPersonForm.trainType,
          language: this.createPersonForm.language,
          isRemoveBg: this.createPersonForm.isRemoveBg,
          isHighQuality: this.createPersonForm.isHighQuality,
          resolutionRate: this.createPersonForm.resolutionRate,
          version: this.createPersonForm.version,
        };
        if (this.createPersonForm.version === '2.0') {
          params.authVideo = this.createPersonForm.authVideoUrl;
          params.authText = this.createPersonForm.authText.trim();
        }

        const response = await createPersonkApi(params);

        if (response && response.code === 0) {
          this.$message.success('数字人创建成功！');
          this.closeCreatePersonDialog();
          // 刷新数字人列表
          await this.getMyPersonList();
        } else {
          this.$message.error(response.msg || '创建失败，请重试');
        }
      } catch (error) {
        console.error('创建数字人失败:', error);
        this.$message.error('创建失败，请重试');
      } finally {
        this.createLoading = false;
      }
    },

    // 关闭创建弹窗
    closeCreatePersonDialog() {
      this.showCreatePersonDialog = false;
      this.resetUpload();
    },

    // 重置创建表单
    resetCreateForm() {
      this.createForm = {
        name: '',
        description: ''
      };
      this.resetUpload();
    },

    // 获取数字人状态
    // 判断数字人是否可用
    isPersonAvailable(human) {
      // 训练完成(progress === 100 或 progress === undefined) 且 status === 2(启用)
      const isTrainingComplete = human.progress === undefined || human.progress === 100;
      return isTrainingComplete && human.status === 2;
    },

    // 获取数字人状态样式类
    getPersonStatusClass(human) {
      // 根据 progress 和 status 判断状态
      // progress: 训练进度 0-100
      // status: 1-启用; 2-禁用
      if (human.progress !== undefined && human.progress < 100) {
        return 'status-training';  // 训练中
      }
      if (human.status === 2) {
        return 'status-active';    // 已完成/启用
      }
      return 'status-disabled';    // 未激活/禁用
    },

    // 获取数字人状态文本
    getPersonStatusText(human) {
      // 根据 progress 和 status 判断状态文本
      if (human.progress !== undefined && human.progress < 100) {
        return '训练中';
      }
      if (human.status === 2) {
        return '已完成';
      }
      return '未激活';
    },

    // 编辑数字人
    editDigitalHuman(human) {
      // 跳转到编辑页面或打开编辑弹窗
      console.log('编辑数字人:', human);
      this.$message.info('编辑功能开发中');
    },

    // 使用数字人
    useDigitalHuman(human) {
      if (!this.isPersonAvailable(human)) {
        this.$message.warning('只有已完成的数字人才能使用');
        return;
      }
      // 选择该数字人并切换到生成视频标签页
      this.selectedAvatar = human;
      this.activeTab = 'generate';
      this.$message.success(`已选择数字人: ${human.personName}`);
    }
  }
}
</script>

<style lang="scss" scoped>
.digital-human-layout {
  padding: 0 !important;
  height: 100%;
  background: #f8fafc;

  .hero-banner {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    position: relative;
    overflow: hidden;

    .hero-banner-content {
      position: relative;
      z-index: 1;
      padding: 20px 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: white;

      .hero-left {
        flex: 1;

        .hero-title {
          font-size: 24px;
          font-weight: 600;
          margin: 0 0 12px 0;
          line-height: 1.3;
        }

        .hero-subtitle {
          font-size: 16px;
          margin: 0 0 24px 0;
          opacity: 0.9;
          line-height: 1.5;
        }

        .hero-actions {
          .create-btn {
            background: rgba(255, 255, 255, 0.2);
            border: 1px solid rgba(255, 255, 255, 0.3);
            color: white;
            padding: 12px 24px;
            border-radius: 8px;
            font-weight: 500;
            backdrop-filter: blur(10px);
            transition: all 0.3s ease;

            &:hover {
              background: rgba(255, 255, 255, 0.3);
              transform: translateY(-2px);
              box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
            }
          }
        }
      }

      .hero-right {
        flex: 0 0 80px;

        .hero-visual {
          width: 80px;
          height: 80px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
      }
    }
  }

  .header {
    display: flex;
    background: #fff;
    border-bottom: 1px solid #e8e8e8;
    padding: 0 20px;

    .item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 16px 24px;
      cursor: pointer;
      font-size: 16px;
      color: #666;
      border-bottom: 2px solid transparent;
      transition: all 0.3s ease;
      font-weight: 500;

      &:hover {
        color: #7848f1;
      }

      &.active {
        color: #7848f1;
        border-bottom-color: #7848f1;
        font-weight: 600;
      }
    }
  }

  .main-content {
    flex: 1;
    padding: 24px;
    height: calc(100vh - 200px);
    overflow: auto;
  }

  .video-section {
    background: white;
    border-radius: 16px;
    padding: 32px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid #f1f5f9;

    .content-layout {
      display: flex;
      gap: 40px;

      .video-left {
        flex: 2;
      }

      .video-right {
        flex: 1;
      }
    }
  }

  .management-section {
    background: white;
    border-radius: 16px;
    padding: 32px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid #f1f5f9;

    .pagination-container{
      display: flex;
      justify-content: center;
      padding: 24px 0;
      border-top: 1px solid #f0f0f0;
      margin-top: 24px;
    }
  }

  .section-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e5e7eb;

    .section-title {
      font-size: 18px;
      font-weight: 600;
      color: #1f2937;
    }
  }

  .video-preview {
    position: relative;
    width: 100%;
    padding: 20px;
    text-align: center;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 12px;
    margin-bottom: 20px;
    overflow: hidden;
    border: 2px dashed #e2e8f0;
    transition: all 0.3s ease;
    box-sizing: border-box;

    &:hover {
      border-color: #7848f1;
      background: linear-gradient(135deg, #f8fafc 0%, #f0f4ff 100%);
    }

    .video-preview-image {
      width: 160px; // 手机尺寸宽度
      height: 280px; // 手机尺寸高度，保持9:16比例
      margin: 0 auto;
    }

    .image-slot {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 16px;

      .placeholder-icon {
        width: 80px;
        height: 80px;
        background: rgba(120, 72, 241, 0.1);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 16px;
      }

      .avatar-info-overlay {
        text-align: center;
        color: #64748b;

        .avatar-name {
          font-size: 16px;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 4px;
        }

        .avatar-type {
          font-size: 14px;
          color: #7848f1;
          background: rgba(120, 72, 241, 0.1);
          padding: 4px 12px;
          border-radius: 12px;
          display: inline-block;
        }
      }
    }
  }

    .video-player {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .video-info {
      position: absolute;
      bottom: 16px;
      left: 16px;
      right: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .duration {
        background: rgba(0, 0, 0, 0.8);
        color: white;
        padding: 6px 12px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 500;
        backdrop-filter: blur(10px);
      }

      .download-btn {
        background: rgba(0, 0, 0, 0.8);
        color: white;
        padding: 0 8px;
        border-radius: 6px;
        cursor: pointer;
        backdrop-filter: blur(10px);
        transition: all 0.2s ease;

        &:hover {
          background: rgba(0, 0, 0, 0.9);
        }
      }
    }
  }
  .text-input-section {
    padding-top: 20px;

    .input-title {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 16px;
      color: #1e293b;
      display: flex;
      align-items: center;
      gap: 8px;

      &::before {
        content: '';
        width: 4px;
        height: 20px;
        background: #7848f1;
        border-radius: 2px;
      }
    }

    .bg-section {
      margin-bottom: 20px;

      .bg-header {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 12px;

        .input-title {
          margin-bottom: 0;
        }

        .bg-optional {
          font-size: 13px;
          font-weight: 400;
          color: #94a3b8;
        }

        .bg-tip {
          font-size: 12px;
          color: #94a3b8;
        }

        .bg-tip-disabled {
          color: #f59e0b;
        }
      }

      .bg-body {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-top: 12px;
      }

      .bg-empty,
      .bg-thumb {
        width: 96px;
        height: 96px;
        border-radius: 12px;
        overflow: hidden;
        cursor: pointer;
      }

      .bg-empty {
        border: 2px dashed #e2e8f0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 6px;
        color: #94a3b8;
        font-size: 12px;

        i {
          font-size: 24px;
        }

        &:hover {
          border-color: #7848f1;
          color: #7848f1;
        }
      }

      .bg-thumb {
        position: relative;
        border: 2px solid #e2e8f0;

        .bg-thumb-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        .bg-thumb-mask {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          padding: 4px 0;
          background: rgba(0, 0, 0, 0.55);
          color: #fff;
          font-size: 12px;
          text-align: center;
        }
      }

      .bg-meta {
        .bg-meta-line {
          margin: 0;
          font-size: 12px;
          color: #94a3b8;
        }

        .bg-clear {
          padding: 4px 0 0;
          color: #f56c6c;
        }
      }
    }

    .text-input {
      margin-bottom: 20px;

      ::v-deep .el-textarea__inner {
        border-radius: 12px;
        border: 2px solid #e2e8f0;
        padding: 16px;
        font-size: 14px;
        line-height: 1.6;
        transition: all 0.3s ease;

        &:focus {
          border-color: #7848f1;
          box-shadow: 0 0 0 3px rgba(120, 72, 241, 0.1);
        }
      }
    }

    .generate-actions {
      text-align: center;

      .generate-btn {
        background: linear-gradient(135deg, #7848f1 0%, #6366f1 100%);
        border: none;
        padding: 14px 40px;
        border-radius: 12px;
        font-weight: 600;
        font-size: 16px;
        box-shadow: 0 4px 15px rgba(120, 72, 241, 0.3);
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(120, 72, 241, 0.4);
        }

        &:active {
          transform: translateY(0);
        }
      }
    }
  }

  .subsection-title {
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 0 ;

    &::before {
      content: '';
      width: 3px;
      height: 16px;
      background: #7848f1;
      border-radius: 2px;
    }
  }

  .avatar-section {
    margin-bottom: 32px;
    
    .avatar-preview {
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #F8FAFC;
      border-radius: 12px;
      padding: 10px 0;

      .avatar-video-container {
        position: relative;
        width: 160px; // 手机尺寸宽度
        height: 280px; // 手机尺寸高度，保持9:16比例
        background: #f5f5f5;
        border-radius: 12px;
        border: 2px solid #e2e8f0;
        overflow: hidden;
        margin-bottom: 12px;

        .video-placeholder {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }

        .switch-btn {
          position: absolute;
          top: 8px;
          right: 8px;
          padding: 4px 8px;
          font-size: 12px;
          border-radius: 4px;
          background: rgba(120, 72, 241, 0.9);
          border: none;
          color: white;
          backdrop-filter: blur(10px);

          &:hover {
            background: rgba(120, 72, 241, 1);
          }
        }
      }

      .avatar-name-display {
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #1e293b;
        padding: 8px 0;
      }
    }
  }

  // 数字人选择对话框样式
  ::v-deep .avatar-selector-dialog {
    .el-dialog__header {
      padding: 20px 24px 16px;
      border-bottom: 1px solid #e2e8f0;

      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #1e293b;
      }
    }

    .el-dialog__body {
      padding: 0;
    }

    .dialog-tabs {
      display: flex;
      padding: 20px 24px 0;
      gap: 12px;

      .tab-btn {
        flex: 1;
        padding: 12px 24px;
        border-radius: 8px;
        font-weight: 500;
        border: 2px solid #e2e8f0;
        background: white;
        color: #64748b;

        &.active {
          background: #7848f1;
          border-color: #7848f1;
          color: white;
        }

        &:not(.active):hover {
          border-color: #7848f1;
          color: #7848f1;
        }
      }
    }

    .avatar-content {
      padding: 20px 24px;

      .avatar-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        .avatar-category {
          font-size: 16px;
          font-weight: 600;
          color: #1e293b;
        }

        .avatar-count {
          font-size: 14px;
          color: #64748b;
        }
      }

      .avatar-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;

        .avatar-card {
          cursor: pointer;
          border-radius: 12px;
          border: 2px solid #e2e8f0;
          overflow: hidden;
          transition: all 0.3s ease;
          background: white;

          &:hover {
            border-color: #cbd5e1;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          }

          &.active {
            border-color: #3b82f6;
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
          }

          .avatar-video {
            position: relative;
            width: 100%;
            height: 340px;
            aspect-ratio: 9/16;
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            border-radius: 8px;

            .avatar-image {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .check-icon {
              position: absolute;
              top: 8px;
              right: 8px;
              width: 24px;
              height: 24px;
              background: #3b82f6;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              color: white;
              font-size: 14px;
            }

            .bg-badge {
              position: absolute;
              left: 8px;
              bottom: 8px;
              padding: 2px 6px;
              background: rgba(120, 72, 241, 0.9);
              color: #fff;
              font-size: 11px;
              line-height: 16px;
              border-radius: 4px;
            }
          }

          .avatar-info {
            padding: 12px;
            text-align: center;

            .avatar-name {
              font-size: 14px;
              font-weight: 600;
              color: #1e293b;
              margin-bottom: 4px;
            }

            .usage-count {
              font-size: 12px;
              color: #64748b;
            }
          }
        }

        .empty-state {
          grid-column: 1 / -1;
          text-align: center;
          padding: 40px 20px;
          color: #999;

          p {
            margin-top: 16px;
            font-size: 14px;
          }
        }
      }

      .pagination-wrapper {
        display: flex;
        justify-content: center;
        padding: 24px 0;
        border-top: 1px solid #f0f0f0;
        margin-top: 24px;
      }
    }

    .el-dialog__footer {
      padding: 16px 24px 20px;
      border-top: 1px solid #e2e8f0;
      text-align: right;

      .el-button {
        padding: 10px 20px;
        border-radius: 8px;
        font-weight: 500;

        &:first-child {
          margin-right: 12px;
        }
      }
    }
  }

  .professional-section {
    margin: 32px 0;
    padding: 24px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 12px;
    border: 2px dashed #cbd5e1;
    text-align: center;
    color: #64748b;
    transition: all 0.3s ease;

    &:hover {
      border-color: #7848f1;
      background: linear-gradient(135deg, #f8fafc 0%, #f0f4ff 100%);
    }
  }

  .history-section {
    .history-list {
      min-height: 200px;
      padding-right: 8px;

      .history-empty {
        text-align: center;
        padding: 40px 20px;
        color: #999;

        p {
          margin-top: 12px;
          font-size: 14px;
        }
      }

      .history-item {
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 16px;
        border-radius: 12px;
        margin-bottom: 12px;
        transition: all 0.3s ease;
        border: 2px solid #f1f5f9;
        background: white;

        &:hover {
          background: #f8fafc;
          border-color: #e2e8f0;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .history-icon {
          width: 36px;
          height: 36px;
          background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .history-info {
          flex: 1;

          .history-title {
            font-size: 14px;
            font-weight: 600;
            color: #1e293b;
            margin-bottom: 6px;
          }
          .history-type {
              background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
              color: #7848f1;
              padding: 2px 8px;
              border-radius: 6px;
              font-weight: 600;
          }

          .history-meta {
            display: flex;
            gap: 12px;
            font-size: 12px;
            color: #64748b;
            margin-top: 4px;

            .history-duration {
              font-weight: 600;
            }
          }
        }

        .history-actions {
          display: flex;
          gap: 8px;

          .el-button {
            width: 32px;
            height: 32px;
            padding: 0;
            border-radius: 8px;
            border: 2px solid #e2e8f0;
            background: white;
            transition: all 0.3s ease;

            &:hover {
              border-color: #7848f1;
              background: #f0f4ff;
            }
          }
        }
      }
    }

    .history-pagination {
      display: flex;
      justify-content: center;
      padding: 24px 0;
      border-top: 1px solid #f0f0f0;
      margin-top: 24px;
    }
  }

  /* 数字人管理页面样式 */
  .management-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
    padding-bottom: 20px;
    border-bottom: 2px solid #e2e8f0;

    .management-title {
      font-size: 24px;
      font-weight: 700;
      color: #1e293b;
      margin: 0;
      display: flex;
      align-items: center;
      gap: 12px;

      &::before {
        content: '';
        width: 4px;
        height: 24px;
        background: linear-gradient(135deg, #7848f1 0%, #6366f1 100%);
        border-radius: 2px;
      }
    }

    .create-digital-human-btn {
      background: linear-gradient(135deg, #7848f1 0%, #6366f1 100%);
      border: none;
      padding: 12px 24px;
      border-radius: 12px;
      font-weight: 600;
      box-shadow: 0 4px 15px rgba(120, 72, 241, 0.3);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(120, 72, 241, 0.4);
      }
    }
  }

  .add-digital-human-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 16px;
    padding: 48px;
    text-align: center;
    color: white;
    margin-bottom: 32px;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="dots" width="20" height="20" patternUnits="userSpaceOnUse"><circle cx="10" cy="10" r="1" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100" height="100" fill="url(%23dots)"/></svg>');
      opacity: 0.5;
    }

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 30px rgba(102, 126, 234, 0.3);
    }

    .add-card-content {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px;
      font-size: 18px;
      font-weight: 600;
    }
  }

  .digital-human-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 24px;

    .digital-human-card {
      background: white;
      border: 2px solid #f1f5f9;
      border-radius: 16px;
      overflow: hidden;
      transition: all 0.3s ease;
      cursor: pointer;

      &:hover {
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
        transform: translateY(-4px);
        border-color: #e2e8f0;
      }

      .card-image {
        position: relative;
        height: 220px;
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        display: flex;
        align-items: center;
        justify-content: center;

        .image-placeholder {
          width: 96px;
          height: 96px;
          background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        .status-badge {
          position: absolute;
          top: 16px;
          right: 16px;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          backdrop-filter: blur(10px);

          &.active {
            background: rgba(220, 252, 231, 0.9);
            color: #166534;
            border: 1px solid rgba(22, 101, 52, 0.2);
          }

          &.training {
            background: rgba(254, 243, 199, 0.9);
            color: #92400e;
            border: 1px solid rgba(146, 64, 14, 0.2);
          }

          &.inactive {
            background: rgba(243, 244, 246, 0.9);
            color: #6b7280;
            border: 1px solid rgba(107, 114, 128, 0.2);
          }
        }
      }

      .card-content {
        padding: 24px;

        .card-title {
          font-size: 18px;
          font-weight: 600;
          color: #1e293b;
          margin: 0 0 12px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .card-info {
          display: flex;
          gap: 8px;
          margin-bottom: 12px;
          flex-wrap: wrap;

          .info-item {
            font-size: 12px;
            color: #64748b;
            background: #f1f5f9;
            padding: 4px 10px;
            border-radius: 12px;
          }
        }

        .card-meta {
          font-size: 14px;
          color: #64748b;
          margin: 0 0 20px 0;
          font-weight: 500;

          .usage-count {
            display: inline-block;
          }
        }

        .card-actions {
          display: flex;
          gap: 12px;

          .el-button {
            flex: 1;
            border-radius: 8px;
            font-weight: 500;
            transition: all 0.3s ease;

            &:first-child {
              border: 2px solid #e2e8f0;
              background: white;
              color: #64748b;

              &:hover {
                border-color: #7848f1;
                color: #7848f1;
                background: #f0f4ff;
              }
            }

            &:last-child {
              background: linear-gradient(135deg, #7848f1 0%, #6366f1 100%);
              border: none;
              color: white;

              &:hover {
                transform: translateY(-1px);
                box-shadow: 0 4px 12px rgba(120, 72, 241, 0.3);
              }
            }
          }
        }
      }
    }
  }

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

// 进度弹窗样式
.progress-dialog {
  .el-dialog__body {
    padding: 0;
  }
}

.progress-dialog-content {
  text-align: center;
  padding: 30px 20px;
  background: #f8f9fa;

  .avatar-container {
    margin-bottom: 20px;
    position: relative;
    display: inline-block;

    .avatar-image {
      width: 160px;
      height: 280px;
      border-radius: 12px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    }

    .avatar-placeholder {
      width: 160px;
      height: 280px;
      border-radius: 12px;
      background: linear-gradient(135deg, #f1f3f4 0%, #e8eaed 100%);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .play-icon-container {
    margin-bottom: 20px;

    .play-icon {
      width: 60px;
      height: 60px;
      background: linear-gradient(135deg, #4285f4 0%, #1a73e8 100%);
      border-radius: 50%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 12px rgba(66, 133, 244, 0.3);
    }
  }

  .progress-info {
    margin-bottom: 30px;

    .progress-text {
      font-size: 16px;
      font-weight: 500;
      color: #333;
      margin-bottom: 16px;
    }

    .progress-bar-container {
      margin-bottom: 12px;

      .progress-bar {
        width: 200px;
        height: 6px;
        background: #e8eaed;
        border-radius: 3px;
        margin: 0 auto;
        overflow: hidden;

        .progress-bar-fill {
          height: 100%;
          background: linear-gradient(90deg, #4285f4 0%, #1a73e8 100%);
          border-radius: 3px;
          transition: width 0.3s ease;
        }
      }
    }

    .progress-message {
      font-size: 14px;
      color: #666;
    }
  }

  .progress-actions {
    display: flex;
    justify-content: center;
    gap: 12px;

    .el-button {
      min-width: 100px;
    }
  }
}

// 创建数字人弹窗样式
.create-person-dialog {
  .el-dialog__body {
    padding: 0;
  }
}

.create-person-content {
  padding: 0 30px;

  .dialog-title {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 24px;
    text-align: center;
  }

  .requirements-section {
    margin-bottom: 20px;

    .section-title {
      font-size: 14px;
      font-weight: 600;
      color: #374151;
      margin-bottom: 8px;
    }

    .requirements-list {
      margin: 0;
      padding-left: 0;
      list-style: none;

      li {
        font-size: 13px;
        color: #6b7280;
        margin-bottom: 4px;
        line-height: 1.5;
      }
    }

    .requirement-text {
      font-size: 13px;
      color: #6b7280;
      line-height: 1.6;
      margin: 0;
    }
  }

  // 上传区域样式
  .upload-section {
    margin-bottom: 24px;
    ::v-deep .el-upload {
      width: 100%;
    }

    .upload-area {
      border: 2px dashed #d1d5db;
      border-radius: 12px;
      padding: 40px 20px;
      text-align: center;
      transition: all 0.3s ease;
      background: #fafafa;
      width: 100%;
      box-sizing: border-box;

      &:hover {
        border-color: #4285f4;
        background: #f8fafc;
      }

      &.uploading {
        border-color: #4285f4;
        background: #f0f4ff;
      }

      .upload-placeholder {
        .upload-text {
          font-size: 16px;
          font-weight: 500;
          color: #374151;
          margin: 12px 0 8px;
        }

        .upload-hint {
          font-size: 12px;
          color: #6b7280;
          margin: 0;
        }
      }

      .upload-progress {
        .progress-text {
          font-size: 12px;
          color: #4285f4;
          font-weight: 500;
        }

        .upload-status {
          font-size: 14px;
          color: #6b7280;
          margin: 12px 0 0;
        }
      }

      .upload-success {
        .success-text {
          font-size: 16px;
          font-weight: 500;
          color: #67c23a;
          margin: 12px 0 16px;
        }
      }
    }
  }

  // 表单样式
  .person-form {
    margin-bottom: 24px;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
  }

  .dialog-actions {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 30px;

    .upload-btn {
      background: #4285f4;
      border-color: #4285f4;
      padding: 12px 40px;
      font-size: 14px;
      font-weight: 500;

      &:hover {
        background: #1a73e8;
        border-color: #1a73e8;
      }

      &:disabled {
        background: #d1d5db;
        border-color: #d1d5db;
        color: #9ca3af;
      }
    }

    .cancel-btn {
      padding: 12px 40px;
      font-size: 14px;
      color: #6b7280;
      border-color: #d1d5db;

      &:hover {
        color: #374151;
        border-color: #9ca3af;
      }
    }
  }
}

// 空状态样式
.empty-state-container {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;

  .empty-state {
    text-align: center;
    max-width: 400px;

    .empty-icon {
      width: 80px;
      height: 80px;
      background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 24px;

      i {
        font-size: 36px;
        color: #9ca3af;
      }
    }

    .empty-title {
      font-size: 20px;
      font-weight: 600;
      color: #374151;
      margin-bottom: 12px;
    }

    .empty-description {
      font-size: 14px;
      color: #6b7280;
      line-height: 1.6;
      margin-bottom: 24px;
    }

    .empty-action-btn {
      background: #7848f1;
      border-color: #7848f1;
      padding: 12px 24px;
      font-size: 14px;
      font-weight: 500;

      &:hover {
        background: #6d28d9;
        border-color: #6d28d9;
      }

      i {
        margin-right: 6px;
      }
    }
  }
}

// 数字人卡片样式优化
.digital-human-card {
  .human-image {
    width: 100%;
    height: 200px;
    border-radius: 8px;
  }

  .card-meta {
    margin-bottom: 12px;

    .usage-count {
      font-size: 12px;
      color: #6b7280;
    }
  }

  .status-badge {
    &.status-training {
      background: #fbbf24;
      color: white;
    }

    &.status-active {
      background: #10b981;
      color: white;
    }

    &.status-disabled {
      background: #6b7280;
      color: white;
    }
  }
}

/* ===== 蝉镜功能补全：音色/高级参数/收费/音色训练 ===== */
.voice-select-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 16px;

  .voice-select-label {
    font-size: 14px;
    color: #333;
    white-space: nowrap;
  }
  .voice-select {
    flex: 1;
    max-width: 260px;
  }
}

.advanced-section {
  margin-top: 16px;
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;

  .advanced-toggle {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 14px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    background: #fafafa;
    user-select: none;

    &:hover { color: #7848f1; }
  }
  .advanced-body {
    padding: 8px 14px 14px;

    .adv-row {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 8px 0;
      border-bottom: 1px dashed #f0f0f0;

      &:last-child { border-bottom: none; }

      .adv-label {
        width: 72px;
        font-size: 13px;
        color: #666;
        flex-shrink: 0;
      }
    }
    .adv-row-offset .adv-offset {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;

      .adv-offset-label { font-size: 12px; color: #999; }
      .el-input-number--mini { width: 110px; }
    }
  }
}

.fee-section {
  margin-top: 14px;
  padding: 12px 14px;
  background: #f7f5ff;
  border: 1px solid #e9e3ff;
  border-radius: 8px;
  font-size: 13px;
  color: #555;

  .fee-line {
    display: flex;
    gap: 18px;
    flex-wrap: wrap;
    .fee-item b { color: #7848f1; }
  }
  .fee-estimate {
    margin-top: 6px;
    color: #333;
    b { color: #7848f1; font-size: 15px; }
    .fee-shortfall { color: #f56c6c; margin-left: 8px; }
  }
  .fee-note {
    margin-top: 6px;
    font-size: 12px;
    color: #999;
  }
}

.fee-hint {
  margin: 10px 0;
  font-size: 13px;
  color: #909399;
  b { color: #7848f1; }
}

.form-hint {
  margin-left: 10px;
  font-size: 12px;
  color: #bbb;
}

/* 音色训练 */
.voice-training-section {
  padding: 8px 0;

  .voice-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
    margin-top: 12px;
    min-height: 120px;
  }

  .voice-card {
    border: 1px solid #eee;
    border-radius: 10px;
    padding: 14px;
    background: #fff;
    transition: box-shadow .2s;

    &:hover { box-shadow: 0 4px 16px rgba(120, 72, 241, .1); }

    .voice-card-head {
      display: flex;
      align-items: center;
      gap: 10px;

      .voice-icon {
        font-size: 22px;
        color: #7848f1;
        background: #f2ecff;
        padding: 8px;
        border-radius: 8px;
      }
      .voice-info { flex: 1; min-width: 0; }
      .voice-name {
        font-size: 15px;
        font-weight: 600;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .voice-meta {
        margin-top: 4px;
        display: flex;
        gap: 10px;
        font-size: 12px;

        .voice-lang { color: #999; }
        .voice-status {
          &.vs-1 { color: #e6a23c; }
          &.vs-2 { color: #67c23a; }
          &.vs-4 { color: #f56c6c; }
        }
      }
    }

    .voice-err {
      margin-top: 8px;
      font-size: 12px;
      color: #f56c6c;
    }

    .voice-card-actions {
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;

      .voice-audio { height: 32px; max-width: 200px; }
      .voice-audio-placeholder { font-size: 12px; color: #bbb; }
      .voice-del { color: #f56c6c; }
    }
  }
}

/* 克隆声音弹窗 */
.create-audio-content {
  .audio-tip {
    font-size: 13px;
    color: #909399;
    margin: 0 0 12px;
  }
  .audio-uploader { display: block; }
  .audio-upload-box {
    border: 1px dashed #d9d9d9;
    border-radius: 8px;
    padding: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 13px;
    color: #666;
    transition: border-color .2s;

    &:hover { border-color: #7848f1; }
    .audio-preview { margin-top: 8px; height: 34px; max-width: 100%; }
  }
  .audio-form { margin-top: 14px; }
  .dialog-actions {
    margin-top: 6px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>
